import { PlatformIcon, PLATFORM_META } from "@/components/PlatformBadge";
import { fmtCompact } from "@/lib/format";
import DeltaBadge from "@/components/DeltaBadge";

export default function SocialPerformance({ social }) {
  if (!social?.length) return null;
  return (
    <section data-testid="social-performance">
      <h2 className="mb-4 font-heading text-2xl font-bold tracking-tight">Social Performance</h2>
      <div className="grid gap-4 sm:grid-cols-3">
        {social.map((s) => {
          const meta = PLATFORM_META[s.platform];
          return (
            <div key={s.platform} data-testid={`social-${s.platform}`} className="rounded-2xl border border-border/60 bg-card p-5 shadow-sm transition-shadow hover:shadow-md">
              <div className="flex items-center gap-2.5">
                <span className="grid h-9 w-9 place-items-center rounded-xl" style={{ backgroundColor: `${meta.color}1a` }}>
                  <PlatformIcon platform={s.platform} className="h-5 w-5" />
                </span>
                <p className="font-semibold">{s.label}</p>
              </div>
              <div className="mt-5 flex items-end justify-between">
                <div>
                  <p className="font-heading text-3xl font-bold">{fmtCompact(s.followers)}</p>
                  <p className="text-xs text-muted-foreground">Followers</p>
                </div>
                <DeltaBadge value={s.reach_delta} />
              </div>
              <div className="mt-4 grid grid-cols-2 gap-3 border-t border-border/60 pt-4 text-sm">
                <div><p className="font-semibold">{fmtCompact(s.reach)}</p><p className="text-xs text-muted-foreground">{s.platform === "linkedin" ? "Unique Impr." : "Reach"}</p></div>
                <div><p className="font-semibold">{fmtCompact(s.impressions)}</p><p className="text-xs text-muted-foreground">Impressions</p></div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
